import {isNotNil} from 'ramda';

import type {Nullish} from 'shared/web';

import {GetAllEnumsResponse} from '../../../types/api/api';

/**
 * If `fieldValue` contains a key in the subtree rooted at `subtreeRoot` (inclusive of the root,
 * and walking children), returns the first such key. Otherwise `null`.
 */
export function findSelectedKeyInFieldUnderFeatureSubtree(
  subtreeRoot: string,
  fieldValue: string[] | Nullish,
  allKeys: GetAllEnumsResponse[number]['keys']
): string | null {
  if (fieldValue?.includes(subtreeRoot)) {
    return subtreeRoot;
  }
  const children = allKeys.filter((f) => f.parent === subtreeRoot).map((f) => f.const_key);
  for (const child of children) {
    const result = findSelectedKeyInFieldUnderFeatureSubtree(child, fieldValue, allKeys);
    if (isNotNil(result)) {
      return result;
    }
  }
  return null;
}
